/* Copyright (C) nexleader - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written for nexleader <myipsat.com>, 2016-2018
 */

/*global angular*/
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-nexleader-my-passion-profile-verification-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './my-passion-profile-verification-modal.component.html'
})
export class NexleaderMyPassionProfileVerificationModalComponent {
  constructor(private bsModalService: BsModalService) { }

  /**
   * close
   *
   * A close callback function to use
   *
   * ex: someFn()
   */
  close() {
    this.bsModalService.hide();
  }
}
